"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("@chakra-ui/layout"),
    n = require("@chakra-ui/react"),
    r = require("@chakra-ui/spinner"),
    a = e(require("@laliga-cdac2/button")),
    i = e(require("@laliga-cdac2/card")),
    o = require("@laliga-cdac2/icons"),
    l = require("react"),
    c = e(l),
    u = require("@chakra-ui/icons");

function s() {
  return (s = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function d(e, t) {
  if (null == e) return {};
  var n,
      r,
      a = {},
      i = Object.keys(e);

  for (r = 0; r < i.length; r++) {
    t.indexOf(n = i[r]) >= 0 || (a[n] = e[n]);
  }

  return a;
}

var f = function f(e) {
  var t = e.colorScheme,
      r = e.value;
  return c.createElement(n.Box, Object.assign({
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    color: t + ".500",
    bgColor: t + ".50",
    fontSize: "14px",
    margin: "0 1px",
    textAlign: "center",
    fontWeight: "bold"
  }, e.notificationItemProps), r);
},
    p = function p(e) {
  var n = e.notificacionList,
      r = e.displayFavPanel,
      a = e.isFavEdition,
      i = e.isSelected && (!r || !a),
      s = r && a && e.isFav,
      d = l.useMemo(function () {
    return null == n ? void 0 : n.map(function (e) {
      return c.createElement(f, {
        key: e.id,
        colorScheme: e.colorScheme,
        value: e.value
      });
    });
  }, [n]);
  return c.createElement(t.HStack, null, n && d, i ? c.createElement(u.CheckIcon, {
    color: "corporateCoral.500",
    "data-testid": "selected-icon-test-id"
  }) : s ? c.createElement(o.LikeFilledIcon, {
    color: "corporateYellow.500"
  }) : null);
},
    v = function v(e, t) {
  return void 0 === t && (t = !0), (n = e) && "string" == typeof n ? "unknown.png" === e ? "https://storageprodmzapp.blob.core.windows.net/assets/escudos/" + e : t ? e : "https://storageprodmzapp.blob.core.windows.net/assets/escudos/" + e : "";
  var n;
},
    m = ["fullUrl", "onChange", "selected", "children", "isFavEdition", "isFav", "displayFavPanel", "notificationsList"],
    g = function g(e) {
  var t = e.fullUrl,
      r = e.onChange,
      a = e.selected,
      i = e.children,
      o = e.isFavEdition,
      u = e.isFav,
      s = void 0 !== u && u,
      f = e.displayFavPanel,
      g = void 0 !== f && f,
      h = e.notificationsList,
      b = d(e, m),
      x = l.useRef(null);
  return c.createElement(n.Box, {
    display: "block",
    maxWidth: ["100%", "100%", "50%", 100 / 3 + "%", 100 / 3 + "%", "25%"],
    flex: ["0 0 100%", "0 0 100%", "0 0 50%", "0 0 " + 100 / 3 + "%", "0 0 " + 100 / 3 + "%", "0 0 25%"]
  }, c.createElement(n.HStack, {
    alignItems: "center",
    justifyContent: "space-between",
    _hover: {
      backgroundColor: "corporateGrey.100"
    },
    borderRadius: "3px",
    opacity: !g || !o || o && s ? "1" : "0.35",
    cursor: "pointer",
    paddingEnd: "9",
    onClick: function onClick() {
      return r(b);
    },
    "data-testid": "select-team-button-test-id"
  }, c.createElement(n.HStack, {
    maxW: "75%"
  }, c.createElement(n.Image, {
    h: "32px",
    src: v(b.shieldUrl || "unknown.png", t),
    ref: x,
    onError: function onError() {
      var e;
      null != (e = x.current) && e.src && (x.current.src = v("unknown.png"));
    }
  }), i ? c.createElement(n.Box, null, i) : c.createElement(n.Text, {
    whiteSpace: "initial",
    fontWeight: a && !o ? "bold" : "",
    isTruncated: !0
  }, b.name)), c.createElement(p, {
    isFav: s,
    displayFavPanel: g,
    isFavEdition: o,
    isSelected: a,
    notificacionList: h
  })));
},
    h = ["data", "managedClubsIds", "selectedClub", "fullUrl", "color", "isLoading", "isCard", "displayFavPanel", "onChange", "onSelectFav", "cardProps"];

exports.default = function (e) {
  var u = e.data,
      f = e.managedClubsIds,
      p = e.selectedClub,
      v = e.fullUrl,
      m = e.color,
      b = void 0 === m ? "secondaryColor.100" : m,
      x = e.isLoading,
      E = e.displayFavPanel,
      y = void 0 !== E && E,
      F = e.onChange,
      k = e.onSelectFav,
      w = e.cardProps,
      C = d(e, h),
      S = l.useState(!1),
      P = S[0],
      j = S[1];
  !y && P && j(!1);

  var I = l.useMemo(function () {
    return function (e, t) {
      return e ? e.map(function (e) {
        return s({}, e, {
          isFav: !(isNaN(Number(e.id)) || null == t || !t.includes(Number(e.id)))
        });
      }) : [];
    }(u, f);
  }, [u, f]),
      O = l.useMemo(function () {
    return function (e, t, n) {
      return !t || t && n ? e : e.filter(function (e) {
        return e.isFav;
      });
    }(I, y, P);
  }, [I, y, P]),
      N = function N(e) {
    e && (y && P ? k && k(q(e.id)) : F(e));
  },
      q = function q(e) {
    if (isNaN(Number(e))) return f || [];
    var t = Number(e),
        n = f ? [].concat(f) : [],
        r = n.findIndex(function (e) {
      return e === t;
    });
    return -1 === r ? n = [].concat(n, [t]) : n.splice(r, 1), n;
  };

  return x ? c.createElement(t.Flex, {
    w: "full",
    p: "50px",
    justifyContent: "center"
  }, c.createElement(r.Spinner, {
    thickness: "4px",
    speed: "0.65s",
    emptyColor: "gray.200",
    color: b,
    size: "xl",
    "data-testid": "spinner-test-id"
  })) : c.createElement(i, Object.assign({
    w: "full",
    cardLineColor: b
  }, w), y && c.createElement(a, {
    type: "button",
    variant: "ghost",
    leftIcon: P ? c.createElement(o.ArrowBackIcon, {
      boxSize: "1em"
    }) : void 0,
    onClick: function onClick() {
      return j(function (e) {
        return !e;
      });
    }
  }, P ? "Volver a mis favoritos" : "Marcar mis favoritos"), c.createElement(t.Flex, Object.assign({
    w: "full",
    minWidth: "0",
    flexFlow: "row wrap",
    gridRowGap: "2",
    p: "4"
  }, C), null != O && O.length ? null == O ? void 0 : O.map(function (e) {
    return c.createElement(g, Object.assign({
      key: e.id,
      fullUrl: !!v,
      selected: (t = e, t.id === (null == p ? void 0 : p.id)),
      isFavEdition: P,
      displayFavPanel: y,
      onChange: N
    }, e));
    var t;
  }) : c.createElement(n.Text, {
    p: "8",
    w: "full",
    textAlign: "center"
  }, C.fallback || "No data")));
};